<template>
  <GalleryNew
    v-if="productResponse"
    :images="productResponse.images"
    :product-type="productResponse.type"
    :review="reviewInCarouselResponse || undefined"
    should-preload-first-img
    :tracking-product-model="productResponse.model ?? ''"
  />
</template>

<script setup lang="ts">
import GalleryNew from '~/scopes/product-core/components/presentationals/GalleryNew/GalleryNew.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

import { useFetchReviewInGalleryNew } from './composables/useFetchReviewInGalleryNew/useFetchReviewInGalleryNew'

const { data: productResponse } = useFetchProduct()
const { data: reviewInCarouselResponse } = useFetchReviewInGalleryNew()
</script>
